/*
 widget

 This component represents a single widget object.

 */

import $ from 'jquery';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/resizable';
import ko from 'knockout';
import _ from 'lodash';
import { errorHandler } from '../common';

ko.components.register('widget', {
    viewModel: widget,
    template: {
        element: 'widget-template'
    }
});

export function widget(params) {

    var self = this;

    params = params || {};

    var data = params && params.data ? params.data : params;

    if (data instanceof widget)
        return data;

    //Base props
    var reportsRepo = data.reportsRepo;
    var dashboardsRepo = data.dashboardsRepo;
    self.dashboard = ko.observable(data.dashboard);
    self.id = ko.observable(_.defaultIfNullOrUndefined(data.id, -1));

    //Use for widget domElementId when widget hasn't been saved yet.
    var tempId = _.random(1000000);

    self.dashboardId = ko.observable(_.defaultIfNullOrUndefined(data.dashboardId, -1));
    self.domElementId = ko.observable((function () {
        var id = self.id();
        return "widget-" + (id == -1 ? tempId : id);
    })());

    self.displayCoordinateX = ko.observable(_.defaultIfNullOrUndefined(data.displayCoordinateX, 10));
    self.displayCoordinateY = ko.observable(_.defaultIfNullOrUndefined(data.displayCoordinateY, 10));
    self.displayWidth = ko.observable(_.defaultIfNullOrUndefined(data.displayWidth, 0));
    self.displayHeight = ko.observable(_.defaultIfNullOrUndefined(data.displayHeight, 0));
    self.chartHeightDifference = 30;
    self.chartWidthDifference = 10;
    self.initialChartHeight = ko.observable(self.displayHeight() - self.chartHeightDifference);
    self.initialChartWidth = ko.observable(self.displayWidth() - self.chartWidthDifference);

    self.title = ko.observable(_.defaultIfNullOrUndefined(data.title, ""));
    self.reportTitle = ko.observable(_.defaultIfNullOrUndefined(data.reportTitle, ""));
    self.isDashboardOwner = ko.observable(_.defaultIfNullOrUndefined(data.isDashboardOwner, false));
    self.editMode = ko.observable(_.defaultIfNullOrUndefined(data.editMode, true));
    self.editDashboardWidgetsFeatureEnabled = ko.observable(_.defaultIfNullOrUndefined(data.editDashboardWidgetsFeatureEnabled, false));

    self.hover = ko.observable(false);

    self.numberOfFilters = ko.observable(0);

    self.widgetTypes = ko.observableArray([{ text: "Bar Chart", value: "bar" }, { text: "Pie Chart", value: "pie" }, { text: "Column Chart", value: "column" }, { text: "Line Chart", value: "line" }, { text: "Data Total", value: "total" }, { text: "Record Count", value: "count" }])
    self.widgetTypesIncludingLineTrends = ko.observableArray([{ text: "Bar Chart", value: "bar" }, { text: "Pie Chart", value: "pie" }, { text: "Column Chart", value: "column" }, { text: "Line Chart", value: "line" }, { text: "Line Chart - Trends", value: "linetrends" }, { text: "Data Total", value: "total" }, { text: "Record Count", value: "count" }])
    self.widgetType = ko.observable(_.defaultIfNullOrUndefined(data.widgetType, "").toLowerCase());

    self.widgetTypeCategory = ko.computed(function () {

        var type = self.widgetType();

        if (type === "bar" || type === "column" || type === "line" || type === 'linetrends' || type === "pie")
            return "chart";

        return type;
    });
    self.sortColumn = ko.observable(data.sortColumn || "");
    self.sortField = ko.observable("");
    self.sortDescending = ko.observable(false);

    self.reportId = ko.observable(data.reportId || -1);
    self.topCount = ko.observable(10);
    self.reportColumns = ko.observableArray([]);

    //Do the report columns contain at least one trend value column.
    //This will help determine if we should show a widget type of "Line - Trends" in the edit dropdown.
    self.reportColumnsIncludeValueTrends = ko.computed(function () {
        return (_.filter(self.reportColumns(), function (c) { return c.columnTypeString === "Trend"; })).length > 0;
    });

    self.dataTotalField = ko.observable(data.dataTotalField || "");
    self.dataTotalTitle = ko.observable(data.dataTotalTitle || "");
    self.dataTotalFormat = ko.observable(data.dataTotalFormat || "");
    self.dataTotalAmount = ko.observable(data.dataTotalAmount || 0);
    self.recordCount = ko.observable(0);

    self.showNonChartWidgetLoader = ko.observable(false);
    self.nonChartWidgetStartDate = ko.observable("");
    self.nonChartWidgetEndDate = ko.observable("");
    self.nonChartWidgetDateRange = ko.computed(function () {

        var result = "";

        var start = self.nonChartWidgetStartDate();
        var end = self.nonChartWidgetEndDate();

        if (start.length > 0 && end.length > 0) {

            result = start + " to " + end;
        }

        return result;
    });
    self.nonChartWidgetTitle = ko.computed(function () {

        var result = "";

        var type = self.widgetType();

        if (type === "total")
            return self.dataTotalTitle();

        if (type !== "count")
            return "";

        var title = self.title();

        if (title.length > 0)
            return title;

        return self.reportTitle();;
    });

    self.chartSeries = ko.observableArray([]);
    self.filteredChartSeries = ko.computed(function () {

        if (self.widgetType() === "linetrends")
            return _.uniqBy(self.chartSeries(), "columnId");

        return self.chartSeries();
    });
    self.chartCategoryField = ko.observable(data.chartCategoryField || "");
    self.reportsDropdownDataSource = reportsRepo.getAllReports;
    self.categoryColumnDropdownDataSource = function () {

        var deferred = $.Deferred();

        var reportColumns = self.reportColumns();

        //Filter for columns that have level greater than zero
        var columns = _.sortBy(_.filter(reportColumns, function (col) {
            return col.dataTypeString == "string";
        }), "title");

        if (columns.length === 0) {
            columns = reportColumns.length > 0 ? [reportColumns[0]] : [];
        }

        deferred.resolve(columns);

        return deferred.promise();
    };

    self.valueFieldsDropdownDataSource = function () {

        var deferred = $.Deferred();

        var columns = [];

        if (self.widgetType() === "linetrends") {

            columns = self.reportColumns();

            //Get trend value columns unique by column id
            columns = _.uniqBy(_.filter(self.reportColumns(), function (c) { return c.columnTypeString === "Trend" || c.columnTypeString === "Standard"; }), "columnId");

            //Store the fields that are already in the chartSeries array
            var chartSeriesColumnIds = _.map(self.chartSeries(), "columnId");

            //Filter out columns that are string values or already contained in the chartSeries array.
            columns = _.sortBy(_.filter(columns, function (col) {

                var containedInChartSeriesColumnIds = !_.isNullOrUndefined(_.find(chartSeriesColumnIds, function (id) {
                    return id == col.columnId;
                }));

                return col.dataTypeString !== "string" && !containedInChartSeriesColumnIds;
            }), "title");

            //Use the caption instead of title
            _.forEach(columns, function (c) {
               c.title = c.caption;
            });

        }
        else {

            columns = self.reportColumns();

            //Store the fields that are already in the chartSeries array
            var chartSeriesFields = _.map(self.chartSeries(), "field");

            //Filter out columns that are string values or already contained in the chartSeries array.
            columns = _.sortBy(_.filter(columns, function (col) {

                var containedInChartSeriesFields = !_.isNullOrUndefined(_.find(chartSeriesFields, function (field) {
                    return field == col.field;
                }));

                return col.dataTypeString !== "string" && !containedInChartSeriesFields;
            }), "title");
        }

        deferred.resolve(columns);

        return deferred.promise();
    };

    self.sortFieldsDropdownDataSource = function () {

        var deferred = $.Deferred();

        var columns = self.reportColumns();

        columns = _.sortBy(columns, "title");

        deferred.resolve(columns);

        return deferred.promise();
    };

    self.dataTotalFieldDropdownDataSource = function () {

        var deferred = $.Deferred();

        var reportColumns = self.reportColumns();

        //Filter out columns that are string values
        var columns = _.sortBy(_.filter(reportColumns, function (col) {
            return col.dataTypeString !== "string";
        }), "title");

        deferred.resolve(columns);

        return deferred.promise();
    };

    self.freezeData = ko.observable(true); //Let chart know it should not get data yet, this avoids duplicate requests
    self.reportContentDataSource = reportsRepo.getReportContent;
    self.displayErrors = ko.observableArray([]);
    self.validationErrors = ko.observableArray([]);
    self.showDeletePopup = ko.observable(false);

    self.queries = ko.observableArray([]);

    self.resultsCallbackToWidget = function (dataResults) {
        self.queries([]);

        if(dataResults.queries)
            dataResults.queries.map(x => self.queries.push(x));
    };

    //Public functions

    //Navigate if the title is clicked on
    self.reportTitleClick = function () {
        var url = window.location.href;
        url = url.substring(0, url.lastIndexOf("/"));
        url += "/reports.html?reportId=" + self.reportId();
        window.location.href = url;
    }

    //Move the widget to the top of the stack order in the UI
    self.moveToTop = function (item, event) {

        $(".widget").removeClass("top-level");
        $("#" + self.domElementId()).addClass("top-level");

        //Return true so that the default event handler will be called by KO.
        return true;
    }

    //This is a callback function passed to the charts so that we can track any errors
    //incurred within them.
    self.onWidgetError = function (error) {
        self.displayErrors.push(error);
    }

    self.widgetTypeChanged = function (type) {

        var oldType = self.widgetType();
        var reportTitle = self.reportTitle();

        //Reset these every time
        self.dataTotalField("");
        self.dataTotalTitle("");
        self.dataTotalFormat("");

        //Reset properties if a total widget is selected
        if (type === "total" || type === "count") {

            self.displayHeight(0); //Reset dimensions so that the default will be applied
            self.displayWidth(0); //Reset dimensions so that the default will be applied
            self.topCount(1);
            self.chartSeries([]);
            self.chartCategoryField("");
            self.title(type === "count" && reportTitle !== "" ? "Count " + reportTitle : reportTitle)
        }
        else {

            self.topCount(10);

            if (oldType === "total" || oldType === "count") {
                self.title(reportTitle); //if we switched from total, we need to set the title again
            }

            if (type === "pie") {
                self.topCount(50);
                self.chartSeries([]);
                self.chartCategoryField("");
            }

            //If moving to or away from linetrends, clear the series data
            if (type === "linetrends" || oldType === "linetrends") {
                self.chartSeries([]);
            }
        }

        self.widgetType(type);
    }

    self.categoryFieldChanged = function (newValue, newData) {

        //A new category field was selected. 

        //Clear the series data
        self.chartSeries([]);

        self.chartCategoryField(newValue);
    }

    //Handle a change to the chart series columns
    self.addChartSeriesColumn = function (newValue, newData) {

        var addingFirstSeries = self.chartSeries().length === 0;

        if (self.widgetType() == "linetrends") {

            var matchingColumns = _.filter(self.reportColumns(), function (c) { return c.columnId === newData.columnId && c.columnTypeString.indexOf("Delta") === -1; });

            _.forEach(matchingColumns, function (c) {
                var series = {};
                series.name = c.caption;
                series.field = c.field;
                series.columnId = c.columnId;
                series.trendIndex = c.trendIndex;
                series.format = c.format;
                series.categoryField = self.chartCategoryField();
                self.chartSeries.push(series);
            });
        }
        else {
            var series = {};
            series.name = newData.title;
            series.field = newData.field;
            series.columnId = newData.columnId;
            series.trendIndex = newData.trendIndex;
            series.format = newData.format;
            series.categoryField = self.chartCategoryField();

            self.chartSeries.push(series);
        }

        if (addingFirstSeries) {
            setSortColumn();
        }
    }

    self.removeChartSeriesColumn = function (column) {

        if (self.widgetType() == "linetrends") {

            //Remove all series that have a matching column id
            var seriesToKeep = [];
            _.forEach(self.chartSeries(), function (s) {

                if (s.columnId !== column.columnId) {
                    seriesToKeep.push(s);
                }

            });
            self.chartSeries(seriesToKeep);
        }
        else {

            //Remove the series with the matching field
            var seriesIndex = _.findIndex(self.chartSeries(), function (s) { return s.field === column.field; });
            if (seriesIndex >= 0) {
                var removedSeries = self.chartSeries.splice(seriesIndex, 1);
            }
        }
    }

    var setSortColumn = function () {

        var firstSeries = _.first(self.chartSeries());
        var sortColumn = self.sortColumn();
        var firstColumn = _.first(self.reportColumns());

        if (firstSeries && firstSeries.field) {
            //First choice - set to the first series field
            self.sortColumn(firstSeries.field + " Asc");
        }
        else if (sortColumn && sortColumn.length > 0) {
            //Second choice - the column that is sorted on the report
            self.sortColumn(sortColumn);
        }
        else if (firstColumn && firstColumn.field) {
            //Last choice - the first column
            self.sortColumn(firstColumn.field + " Asc");
        }

        updateSortFields();
    }

    var updateSortFields = function () {
        var sortColumn = self.sortColumn();
        self.sortField(sortColumn && sortColumn.length > 0 ? sortColumn.substring(0, sortColumn.indexOf(" ")) : "");
        self.sortDescending(sortColumn && sortColumn.length > 0 ? sortColumn.indexOf(" Desc") > -1 : false);
    }

    self.dataTotalFieldChanged = function (newValue, newData) {

        //A new data total field was selected. 

        //Update the properties
        self.dataTotalField(newData.field || "");
        self.dataTotalTitle(newData.title || "");
        self.dataTotalFormat(newData.format || "n0");
        self.dataTotalAmount(0);
    }

    self.reportIdChanged = function (id) {

        var widgetType = self.widgetType();

        //If no report was selected...
        if (id <= 0) {
            self.title("");
            self.reportTitle("");
            self.reportColumns([]);
            self.sortColumn("");
            self.nonChartWidgetStartDate("");
            self.nonChartWidgetEndDate("");
            self.dataTotalAmount(0);
            self.dataTotalField("");
            self.dataTotalTitle("");
            self.dataTotalFormat("");

            //Reset the properties involving columns
            self.chartCategoryField("");
            self.chartSeries([]);

            return;
        }

        if (reportsRepo) {
            reportsRepo.getReportFull(id).then(
                function (report) {
                    self.reportId(id);

                    //Update title with the report title if they were already matching.
                    if (self.title() === self.reportTitle())
                        self.title(report.title);

                    self.reportTitle(report.title);
                    self.title(widgetType === "count" && report.title !== "" ? "Count " + report.title : report.title);
                    self.reportColumns(report.columns);
                    self.sortColumn(report.sortColumn);
                    updateSortFields();

                    self.nonChartWidgetStartDate("");
                    self.nonChartWidgetEndDate("");
                    self.dataTotalAmount(0);
                    self.dataTotalField("");
                    self.dataTotalTitle("");
                    self.dataTotalFormat("");

                    //If the widget type requires trend columns, but we don't have any now, reset the widget type.
                    if (self.widgetType() == "linetrends" && self.reportColumnsIncludeValueTrends() === false) {
                        self.widgetType("");
                    }

                    //Reset the properties involving columns
                    self.chartCategoryField("");
                    self.chartSeries([]);

                },
                function (xhr) {
                    errorHandler.processResponse(xhr);
                }
            );
        }
    }

    var getValidationErrors = function () {

        var results = [];

        //Widget type selected?
        if (self.widgetType().length == 0)
            results.push("Widget type must be selected.");

        //Report source selected?
        var reportId = self.reportId();
        if (_.isNullOrUndefined(reportId) || reportId < 0)
            results.push("Report source must be selected.");

        //Total field selected?
        if (self.widgetTypeCategory() == "total") {
            if (self.dataTotalField().length == 0)
                results.push("Total field must be selected.");
        }
        else if (self.widgetTypeCategory() == "chart") {

            //Category field selected?
            if (self.chartCategoryField().length == 0)
                results.push("Category field must be selected.");

            //Value field selected?
            if (self.chartSeries().length == 0) {
                results.push("At least one value field must be selected.");
            }
            else {
                var valueFieldIsValid = true;
                _.forEach(self.chartSeries(), function (series) {
                    if (series.field.length == 0)
                        valueFieldIsValid = false;
                });

                if (!valueFieldIsValid)
                    results.push("At least one value field must be selected.");
            }

        }

        return results;
    }

    self.saveWidget = function (reload) {

        setWidgetDimensions();

        var widget = ko.toJS(self);

        if (dashboardsRepo) {

            var sortColumn = self.sortField();
            if (sortColumn && sortColumn.length > 0) {
                if (self.sortDescending() === true) {
                    sortColumn += " Desc";
                }
                else {
                    sortColumn += " Asc";
                }
            }
            widget.sortColumn = sortColumn;

            dashboardsRepo.saveWidget(widget).then(
                function (newId) {

                    if (self.id() == -1) {
                        self.id(newId)
                    }

                    if (_.defaultIfNullOrUndefined(reload, false) == true) {
                        self.reloadWidget();
                    }
                },
                function (xhr) {
                    errorHandler.processResponse(xhr);
                }
            );
        }
    }

    self.saveWidgetButtonClick = function (event, ui) {

        self.validationErrors(getValidationErrors());

        if (self.validationErrors().length > 0)
            return;

        self.editMode(false);

        if (self.widgetType() === "total" || self.widgetType() === "count") {
            self.showNonChartWidgetLoader(true);
        }

        self.freezeData(true);

        self.saveWidget(true);
    }

    self.saveWidgetAfterPositioning = function (event, ui) {

        //If there are validation errors, don't save the widget just yet.
        if (self.editMode()) {

            //In Chrome, this fixes the issue where the content expands but the widget container doesn't.
            $(event.target).css("height", "auto");

            var errors = getValidationErrors();

            if (errors.length > 0)
                return;
        }

        self.saveWidget(false);
    }

    self.editWidget = function () {
        self.displayErrors([]);
        self.editMode(true);
        getReportColumns();
        setWidgetPositionInDOM();
    }

    self.widgetEditorLoaded = function () {

        var theme = localStorage.getItem('selectedTheme');
        if (theme == null) {
            theme = "Office365";
        }

        if (theme.indexOf("Black") > -1) {
            $("#dashboard-widgets-container").css("background-color", "gray");

            var cols = document.getElementsByClassName('widget-container');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.backgroundColor = '#1C1C1C';
            }

            var cols = document.getElementsByClassName('widget');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.backgroundColor = 'black';
            }


            var cols = document.getElementsByClassName('chart-title');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#5BBAF9';
            }

            var cols = document.getElementsByClassName('non-chart-widget-report-title');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#5BBAF9';
            }

            var cols = document.getElementsByClassName('non-chart-widget-value');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#FFFFFF';
            }

            var cols = document.getElementsByClassName('non-chart-widget-title');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#FFFFFF';
            }

            var cols = document.getElementsByClassName('non-chart-widget-date-range');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#FFFFFF';
            }

            var cols = document.getElementsByClassName('chart-date-range');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#FFFFFF';
            }

            var cols = document.getElementsByClassName('widget-editor-text');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#FFFFFF';
            }

            document.body.style.backgroundColor = 'gray';

        }
        else {
            $("#dashboard-widgets-container").css("background-color", "gainsboro");
            document.body.style.backgroundColor = 'gainsboro';

            var cols = document.getElementsByClassName('widget-container');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.backgroundColor = 'white';
            }

            var cols = document.getElementsByClassName('chart-title');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#5BBAF9';
            }

            var cols = document.getElementsByClassName('non-chart-widget-report-title');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#5BBAF9';
            }

            var cols = document.getElementsByClassName('non-chart-widget-value');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#000000';
            }

            var cols = document.getElementsByClassName('non-chart-widget-title');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#000000';
            }

            var cols = document.getElementsByClassName('non-chart-widget-date-range');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#000000';
            }

            var cols = document.getElementsByClassName('chart-date-range');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = '#000000';
            }

            var cols = document.getElementsByClassName('widget-editor-text');
            for (let i = 0; i < cols.length; i++) {
                cols[i].style.color = 'black';
            }

        }
    }

    self.cancelEdit = function () {

        //If this is a brand new widget, delete it.
        if (self.id() == -1) {
            self.dashboard().deleteWidget(self);
            return;
        }

        self.reloadWidget();
    }

    self.reloadWidget = function () {
        //self.editMode(false);
        self.showNonChartWidgetLoader(true);

        if (self.widgetType() == "total" || self.widgetType() == "count") {
            self.showNonChartWidgetLoader(true);
        }

        self.dashboard().reloadWidget(self);
    }

    self.openQueryDialog = function(){
        if(!_.isNullOrUndefined(self.dashboard().openQueryDialog))
            self.dashboard().openQueryDialog(self.title(), self.queries());
    }

    self.toggleHoverOn = function () {
        self.hover(true);
    }

    self.toggleHoverOff = function () {
        self.hover(false);
    }

    var setWidgetDimensions = function () {

        //If the widget dimensions are less than the default, set them to the default.

        var defaultSize = getDefaultWidgetSize();
        var displayHeightDefault = defaultSize.height;
        var displayWidthDefault = defaultSize.width;

        if (self.displayHeight() < displayHeightDefault || self.displayWidth() < displayWidthDefault) {
            self.displayHeight(displayHeightDefault);
            self.displayWidth(displayWidthDefault);
        }
    }

    var getDefaultWidgetSize = function () {

        var type = self.editMode() ? "edit" : self.widgetTypeCategory();

        //Default sizes
        //NOTE: These also act as the minimum sizes too, so if you increase these numbers it will likely screw up someone's layout
        var defaultWidgetSizes = {
            chart: {
                height: 300,
                width: 500
            },
            total: {
                height: 100,
                width: 150
            },
            count: {
                height: 100,
                width: 150
            },
            edit: {
                height: 300,
                width: 500
            }
        }

        return defaultWidgetSizes[type];
    }

    var setWidgetPositionInDOM = function () {

        var $widget = $("#" + self.domElementId());
        var $container = $widget.parent();
        var containerOffset = $container.offset();

        //The top and left offset come from the database, but we also
        //need to add the offset of the widgets container.
        var top = self.displayCoordinateY() + containerOffset.top;
        var left = self.displayCoordinateX() + containerOffset.left;
        $widget.offset({ top: _.round(top), left: _.round(left) });

        //Set the height and width

        //Get the default dimensions (they are also the minimum dimensions) and determine if we should use them

        var defaultSize = getDefaultWidgetSize();
        var defaultHeight = defaultSize.height;
        var defaultWidth = defaultSize.width;
        var useDefaultDimensions = self.displayHeight() < defaultHeight || self.displayWidth() < defaultWidth;

        var height = useDefaultDimensions ? defaultHeight : self.displayHeight();
        var width = useDefaultDimensions ? defaultWidth : self.displayWidth();

        //Height should be set to "auto" in edit mode.
        $widget.height(self.editMode() ? "auto" : height + "px");
        $widget.css("min-height", defaultHeight + "px");
        $widget.width(width + "px");
        $widget.css("min-width", defaultWidth + "px");
    }

    self.resizeChart = function () {

        //Resize the chart based on the current widget height

        if (self.widgetTypeCategory() !== "chart")
            return;

        var $chart = $("#" + self.domElementId() + "-chart");

        if ($chart.length > 0) {

            var chart = $chart.data("kendoChart");

            var $widget = $("#" + self.domElementId());
            var chartHeight = $widget.height() - self.chartHeightDifference;
            var chartWidth = $widget.width() - self.chartWidthDifference;

            chart.setOptions({
                chartArea: {
                    height: chartHeight,
                    width: chartWidth
                }
            });
        }
    }

    self.afterInitialRendering = function () {

        var $widget = $("#" + self.domElementId());

        //Widgets are marked "display:none" in the HTML
        //until we're ready to show them after rendering. Avoids flickering.
        $widget.show();

        setWidgetDimensions();

        setWidgetPositionInDOM();

        if (self.isDashboardOwner() && self.editDashboardWidgetsFeatureEnabled()) {

            //Set up the jQueryUI resizable
            $widget.resizable({
                stop: function (event, ui) {

                    //Save the new dimensions unless we're in edit mode
                    if (!self.editMode()) {
                        self.displayHeight(_.round($widget.height()));
                        self.displayWidth(_.round($widget.width()));
                        self.resizeChart();
                        self.saveWidgetAfterPositioning(event, ui);
                    }
                },
                resize: function (event, ui) {
                    self.resizeChart();
                }
            });

            ////Set up the jQueryUI draggable
            $widget.draggable({
                grid: [1, 1], //snap to grid (1 by 1 array is the same as not snapping to grid)
                containment: "parent", //constrain dragging to within parent element
                stop: function (event, ui) {

                    //Get the offset of the widget RELATIVE TO THE CONTAINER, not the document.
                    var offset = $(event.target).offset();
                    var $parent = $(event.target).parent();
                    var parentOffset = $parent.offset();

                    //Get the offset for just the widget by subtracting container values.
                    var top = offset.top - parentOffset.top;
                    var left = offset.left - parentOffset.left;

                    //Make sure we store integers. Floating point numbers will cause problem on api side.
                    self.displayCoordinateY(_.round(top));
                    self.displayCoordinateX(_.round(left));

                    self.saveWidgetAfterPositioning(event, ui);
                }
            });
        }

        //Move this widget to top of stack order in DOM
        self.moveToTop();
    }

    self.getNonChartData = function (widgetType) {

        self.showNonChartWidgetLoader(true);

        var args = {};
        args.reportId = self.reportId();
        args.dashboardId = self.dashboardId();
        args.widgetId = self.id();
        args.topCount = self.topCount();

        if (reportsRepo) {
            reportsRepo.getReportContent(args).then(
                function (results) {

                    self.resultsCallbackToWidget(results);

                    self.showNonChartWidgetLoader(false);

                    if (widgetType === "total") {

                        //Get amount
                        var amount = results.summary ? _.defaultIfNullOrUndefined(results.summary[self.dataTotalField()], 0) : 0;
                        self.dataTotalAmount(amount);
                    }
                    else if (widgetType === "count") {

                        var recordCount = results["resultCount"] || 0;
                        self.recordCount(recordCount);
                    }

                    self.numberOfFilters(results.filteredColumns.length);

                    //Get daterange data
                    if (!_.isNullOrUndefined(results.reportDates) && results.reportDates.length > 0) {

                        var dateRange = results.reportDates[0];
                        var startDate = new Date(dateRange.startDate);
                        var endDate = new Date(dateRange.endDate);

                        var formattedStart = (startDate.getMonth() + 1) + '/' + startDate.getDate() + '/' + startDate.getFullYear();
                        var formattedEnd = (endDate.getMonth() + 1) + '/' + endDate.getDate() + '/' + endDate.getFullYear();

                        self.nonChartWidgetStartDate(formattedStart || "");
                        self.nonChartWidgetEndDate(formattedEnd || "");
                    }

                },
                function (xhr) {
                    self.showNonChartWidgetLoader(false);
                    errorHandler.processResponse(xhr);
                }
            );
        }

    }

    //Private functions

    var getReportColumns = function () {

        if (reportsRepo) {
            reportsRepo.getReportColumns(self.reportId()).then(
                function (columns) {
                    self.reportColumns(columns);
                },
                function (xhr) {
                    errorHandler.processResponse(xhr);
                }
            );
        }
    }

    //Init the UI
    var init = function (data) {

        updateSortFields();

        if (self.editMode()) {
            getReportColumns(); //get columns
        }

        var type = self.widgetTypeCategory();
        if (type == "chart") {

            //Add the series data one by one.
            var seriesArray = [];

            _.forEach(data.chartSeries, function (s) {

                var series = s;
                series.categoryField = self.chartCategoryField();
                series.columnId = s.columnId;
                series.trendIndex = s.trendIndex;
                series.name = s.name;

                seriesArray.push(series);
            });

            self.chartSeries(seriesArray);
            self.freezeData(false); //Let the chart know he can go get data now, avoids duplicate requests
        }
        else if (type === "total" || type === "count") {
            self.getNonChartData(type);
        }
    }

    init(data);
}